export default "__VITE_ASSET__v6dR0rAX__"